import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Icon } from '../Icon';
import classNames from 'classnames';
export const RichCheckbox = forwardRef(({ children, label, id, value, onChange, name, size, checked, disabled, color = 'blue', className }, ref) => {
    const wrapperClassName = classNames('flex flex-col rounded-xl w-full rounded-lg', checked &&
        !disabled && {
        'ring-2 ring-secondary bg-secondary-50': color === 'green',
        'ring-2 ring-blue bg-blue-50': color === 'blue',
        'ring-2 ring-orange bg-orange-50': color === 'orange'
    }, {
        'hover:shadow-sm text-gray-700': !disabled,
        'ring-1 ring-gray-400 bg-white hover:bg-gray-50': !checked && !disabled,
        'bg-gray-100 text-gray ring-1 ring-gray-400': disabled
    }, className);
    const labelClassName = classNames('flex break-words items-center gap-3 w-full px-6 py-4 min-h-[68px]', {
        'cursor-pointer': !disabled,
        'text-mBase md:text-base': !size,
        'text-sm': size === 'sm',
        'text-base': size === 'md',
        'text-mBase': size === 'lg'
    });
    const iconClassName = classNames('flex-none rounded border text-white', {
        'w-5 h-5 md:w-4 md:h-4': !size,
        'w-4 h-4': size === 'sm' || size === 'md',
        'w-5 h-5': size === 'lg'
    }, disabled
        ? checked
            ? 'border-gray bg-gray'
            : 'border-gray-400 bg-gray-200 text-gray-200'
        : checked
            ? {
                'bg-secondary border-secondary': color === 'green',
                'bg-blue border-blue': color === 'blue' || color === 'orange'
            }
            : 'bg-white border-gray-400');
    const childrenClassName = classNames('w-full relative before:absolute before:top-0 before:h-px ', `${!disabled && checked
        ? color === 'blue'
            ? 'before:bg-blue-300'
            : 'before:bg-secondary-300'
        : 'before:bg-gray-400'}`, {
        'p-6 before:left-6 before:right-6 md:p-5 before:left-5 before:right-5': !size,
        'p-4 before:left-4 before:right-4': size === 'sm',
        'p-5 before:left-5 before:right-5': size === 'md',
        'p-6 before:left-6 before:right-6': size === 'lg'
    });
    return (_jsxs("div", { className: wrapperClassName, children: [_jsxs("label", { className: labelClassName, htmlFor: id, children: [_jsx("input", { checked: checked, className: "hidden", "data-testid": `rich_checkbox_${checked}`, disabled: disabled, id: id, name: name, ref: ref, type: "checkbox", value: value, onChange: onChange }), _jsx(Icon, { className: iconClassName, name: "check" }), _jsx("span", { className: `font-${checked ? 'bold' : 'semibold'}`, children: label })] }), children && _jsx("div", { className: childrenClassName, children: children })] }));
});
